<script>
import ActiveVehicle from "./ActiveVehicle.vue";
import AppointmentStore from "../../mixins/appointment-store";

export default {
    name: "AppointmentSidebar",

    components: {ActiveVehicle},

    mixins: [AppointmentStore],

    computed: {
        formattedAppointmentDate() {
            return new Intl.DateTimeFormat("nl-NL", {
                day: "numeric",
                month: "long",
                year: "numeric",
                timeZone: "UTC"
            }).format(new Date(this.appointmentStore.date));
        },

        translatedTime() {
            return {
                morning: 'Ochtend',
                afternoon: 'Middag'
            }[this.appointmentStore.time] || ''
        },

        isRequestOffer() {
            return this.appointmentStore.isRequestOffer
        }
    },
}
</script>

<template>
    <div class="vue-appointment-sidebar">
        <div class="active-vehicle">
            <h3 v-if="!appointmentStore.hasVehicleData">Voertuig</h3>

            <div v-if="appointmentStore.hasVehicleData" class="mb-2">
                <ActiveVehicle :request-offer="requestOffer" />

                <hr>

                <input type="text" class="kentekenplaat" readonly :value="appointmentStore?.licensePlate">
            </div>

            <button @click="appointmentStore.handleReset" type="button">Wijzig voertuig</button>
        </div>

        <div v-if="appointmentStore.activeStep > 2 && appointmentStore.hasActiveGarage" class="active-garage mt-4">
            <hr v-if="appointmentStore.hasVehicleData">
            <h3>Vestiging</h3>

            <p class="mb-3">CarProf {{ appointmentStore.activeGarage.title }}</p>

            <template v-if="!isRequestOffer">
                <h4>Voorkeur datum afspraak</h4>
                <p class="d-flex flex-wrap justify-content-between align-items-center mb-0 mt-3">
                    <span class="d-inline-block tag" style="color: currentColor">{{ formattedAppointmentDate }} - {{ translatedTime }}</span>
                </p>
            </template>

            <button @click="appointmentStore.resetGarage" type="button" class="mt-3">Wijzig vestiging</button>
        </div>

        <div v-if="appointmentStore.activeStep === 4 " class="active-services">
            <hr v-if="appointmentStore.hasActiveGarage || appointmentStore.hasVehicleData">
            <h3>Werkzaamheden</h3>

            <ul style="display: grid; gap: 0.5rem" class="list-unstyled">
                <li v-for="service in appointmentStore.activeServices" class="service-row" :key="service.id">
                    {{ service.name }}
                </li>
            </ul>

            <button @click="appointmentStore.resetServices()" class="mt-4">Wijzig werkzaamheden</button>
        </div>
    </div>
</template>